class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      return this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    const variantId = event.target.dataset.quantityVariantId;
    
    const cartItem = event.target.closest('.cart-item');
    const inventoryTracked = cartItem?.dataset.inventoryTracked === 'true';
    const maxQty = inventoryTracked ? (parseInt(cartItem?.dataset.maxQuantity) || Infinity) : Infinity;
    
    let message = '';
    event.target.setCustomValidity('');
    event.target.reportValidity();

    if (Number.isFinite(maxQty) && inputValue > maxQty) {
      const itemText = maxQty === 1
      ? (window.cartStrings?.item || 'item')
      : (window.cartStrings?.items || 'items');
    const errorMessage = window.cartStrings?.inventoryLimitError
      ? window.cartStrings.inventoryLimitError
          .replace('[max_qty]', maxQty)
          .replace('[item_text]', itemText)
      : `Only ${maxQty} ${itemText} were added to your cart due to availability.`;
      
      // Store error message to display after cart updates
      this.pendingErrorMessage = {
        line: index,
        message: errorMessage
      };
    
      event.target.value = maxQty;
      this.updateQuantity(index, maxQty, event, document.activeElement.getAttribute('name'), variantId);
      return;
    }
    
    const errorSelectors = [
      `[id="Line-item-error-${index}"]`,
      `#CartDrawer-LineItemError-${index}`
    ];
    
    errorSelectors.forEach(selector => {
      const errorContainers = document.querySelectorAll(selector);
      
      errorContainers.forEach(errorContainer => {
        const errorElement = errorContainer?.querySelector('.cart-item__error-text');
        
        if (errorElement && errorContainer) {
          errorElement.innerHTML = '';
          errorContainer.classList.add('hidden');
        }
      });
    });
    
    this.updateQuantity(index, inputValue, event, document.activeElement.getAttribute('name'), variantId);
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (Shopify.designMode) {
    }

    return fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then(r => r.text())
      .then(htmlText => {
        const doc = new DOMParser().parseFromString(htmlText, 'text/html');
        const sourceQty = doc.querySelector('cart-items');
        if (sourceQty) this.innerHTML = sourceQty.innerHTML;
      })
      .catch(console.error);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'cart-free-shipping-threshold',
        section: 'freeshipping-bar',
        selector: '.shopify-section',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);
    // Clear any previous error for this line
    this.updateLiveRegions(line, '');

    document.querySelectorAll('.freeshipping-bar').forEach(function(el) {
      el.classList.add('loading');
    });

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';
    const changeUrl = (routes.cart_change_url || '/cart/change.js').replace('/cart/change', '/cart/change.js');

    fetch(changeUrl, { ...fetchConfig(), body })
      .then((response) => response.json().then((data) => {
        if (!response.ok) {
          throw new Error(data.message || data.description || 'Something went wrong');
        }
        return data;
      }))
      .then((parsedState) => {
        const currency =
          parsedState.currency ||
          (window.Shopify && Shopify.currency && Shopify.currency.active) ||
          document.documentElement.getAttribute('data-shop-currency') ||
          'USD';

        const totalPrice = (parsedState.total_price || 0) / 100;

        let formattedPrice = `${totalPrice}`;
        try {
          formattedPrice = new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(totalPrice);
        } catch (e) {
          formattedPrice = `${totalPrice.toFixed(2)} ${currency}`;
        }

        const totalEl1 = document.querySelector('.box-total .totals__total-value');
        const totalEl2 = document.querySelector('.cart_heading .cart_total .price');
        if (totalEl1) totalEl1.textContent = formattedPrice;
        if (totalEl2) totalEl2.textContent = formattedPrice;

        const count = parsedState.item_count ?? 0;
        const countEl = document.querySelector('.cart_heading .cart_total .count');
        if (countEl) {
          const itemLabel = count > 1
            ? (window.cartStrings?.items || 'items')
            : (window.cartStrings?.item || 'item');
          countEl.textContent = `(${count} ${itemLabel})`;
        }
        const countMobile = document.querySelector('.cart_heading--mobile .count-mobile');
        if (countMobile) countMobile.textContent = count;

        const thresholdEl = document.getElementById('free-shipping-threshold');
        const msgEl = document.getElementById('freeshipping-message');
        if (thresholdEl && msgEl) {
          const threshold = (parseFloat(thresholdEl.dataset.value || '0') / 100) || 0;
          const cartTotal = (parsedState.total_price || 0) / 100;
          const remaining = Math.max(threshold - cartTotal, 0);

          const reachedText = msgEl.dataset.achievedMessage || "🎉 You've got free shipping!";
          const notReachedText = msgEl.dataset.notAchievedMessage || "Spend __PLACEHOLDER__ more to get free shipping.";

          let formattedRemaining = `${remaining.toFixed(2)} ${currency}`;
          try {
            formattedRemaining = new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(remaining);
          } catch {}

          const message = cartTotal >= threshold ? reachedText : notReachedText.replace('__PLACEHOLDER__', formattedRemaining);
          const progress = threshold > 0 ? Math.min((cartTotal / threshold) * 100, 100) : 0;

          const progressEl = document.getElementById('progress');
          if (progressEl) progressEl.style.width = `${progress}%`;
          msgEl.textContent = message;
        }

        const paintBlock = () => {
          const quantityElement =
            document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

          // Handle API-level errors (e.g., parsedState.errors)
          if (parsedState.errors) {
            if (quantityElement) {
              const prev = quantityElement.getAttribute('value');
              if (prev != null) quantityElement.value = prev;
            }
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.classList.toggle('is-empty', parsedState.item_count === 0);

          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          const sectionsPayload = parsedState.sections || {};
          this.getSectionsToRender().forEach((section) => {
            const container = document.getElementById(section.id);
            if (!container) return;
            const elementToReplace = container.querySelector(section.selector) || container;

            const htmlForSection = sectionsPayload[section.section];
            if (!htmlForSection) return;
            elementToReplace.innerHTML = this.getSectionInnerHTML(htmlForSection, section.selector);
          });

          // Check if quantity was adjusted by the server (stock limit reached)
          const updatedValue = parsedState.items && parsedState.items[line - 1]
            ? parsedState.items[line - 1].quantity
            : undefined;

          let message = '';
          // Use the quantity parameter, not input value (avoids duplicate ID issue)
          const requestedQuantity = quantity;

          if (Number.isFinite(updatedValue) && updatedValue !== requestedQuantity) {
            message = window.cartStrings?.quantityError
              ? window.cartStrings.quantityError.replace('[quantity]', updatedValue)
              : `You can only add ${updatedValue} of this item to your cart.`;
          }

          this.updateLiveRegions(line, message);

          // Focus handling
          const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem) {
            const focusEl = lineItem.querySelector(`[name="${name}"]`);
            if (focusEl) {
              cartDrawerWrapper ? trapFocus(cartDrawerWrapper, focusEl) : focusEl.focus();
            }
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            const empty = cartDrawerWrapper.querySelector('.drawer__inner-empty');
            const link = cartDrawerWrapper.querySelector('a');
            if (empty && link) trapFocus(empty, link);
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }
        };

        if (window.CartPerformance?.measure) {
          CartPerformance.measure(`${eventTarget}:paint-updated-sections`, paintBlock);
        } else {
          paintBlock();
        }

        try { window.CartPerformance?.measureFromEvent?.(`${eventTarget}:user-action`, event); } catch (e) {}

        if (this.pendingErrorMessage && this.pendingErrorMessage.line === line) {
          const errorLine = this.pendingErrorMessage.line;
          const errorMsg = this.pendingErrorMessage.message;
          
          // Clear the pending message
          this.pendingErrorMessage = null;
          
          // Display the error in all matching containers
          setTimeout(() => {
            const errorSelectors = [
              `[id="Line-item-error-${errorLine}"]`,
              `#CartDrawer-LineItemError-${errorLine}`
            ];
            
            errorSelectors.forEach(selector => {
              const errorContainers = document.querySelectorAll(selector);
              
              errorContainers.forEach(errorContainer => {
                const errorElement = errorContainer?.querySelector('.cart-item__error-text');
                
                if (errorElement && errorContainer) {
                  errorElement.innerHTML = errorMsg;
                  errorContainer.classList.remove('hidden');
                }
              });
            });
          }, 50); // Small delay ensures DOM is ready
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId });
        updateFreeShippingMessage();
        
        const notes = document.querySelectorAll('[id^="Details-CartDrawer"].note_box summary');
        notes.forEach(function(note) {
          note.addEventListener('click', (event) => {
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
          });
        });
      })
      .catch((err) => {
        console.warn('Cart update failed:', err);
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        document.querySelectorAll('.freeshipping-bar').forEach((shippingBar) => shippingBar.classList.remove('loading'));
        
        const row = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (row) {
          const rowInput = row.querySelector('input.quantity__input');
          if (rowInput) {
            rowInput.value = rowInput.getAttribute('value');
          }
        }
        
        // Show error message in the line item error container
        const errorMessage = err.message || err.toString() || window.cartStrings?.error || 'There was an error while updating your cart.';
        this.updateLiveRegions(line, errorMessage);
        
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings?.error || 'There was an error while updating your cart. Please try again.';
      })
      .finally(() => {
        this.disableLoading(line);
        
        // Re-bind slider buttons
        let index = 0;
        const slides = document.querySelectorAll('.cart-drawer .slider__slide');
        const totalSlides = slides.length;

        function showSlide() {
          if (index >= totalSlides) index = 0;
          if (index < 0) index = totalSlides - 1;
          const productsList = document.querySelector('.cart-drawer .products_list');
          if (productsList) {
            productsList.style.transform = `translateX(${-index * 100}%)`;
          }
        }

        const nextBtn = document.querySelector('.cart-drawer .button-slide_next');
        const prevBtn = document.querySelector('.cart-drawer .button-slide_prev');

        if (nextBtn) {
          nextBtn.replaceWith(nextBtn.cloneNode(true));
          document
            .querySelector('.cart-drawer .button-slide_next')
            ?.addEventListener('click', () => {
              index++;
              showSlide();
            });
        }

        if (prevBtn) {
          prevBtn.replaceWith(prevBtn.cloneNode(true));
          document
            .querySelector('.cart-drawer .button-slide_prev')
            ?.addEventListener('click', () => {
              index--;
              showSlide();
            });
        }
      });
  }

  updateLiveRegions(line, message) {
    // ✅ Update ALL error containers
    const errorSelectors = [
      `[id="Line-item-error-${line}"]`,
      `#CartDrawer-LineItemError-${line}`
    ];
    
    errorSelectors.forEach(selector => {
      const lineItemErrors = document.querySelectorAll(selector);
      
      lineItemErrors.forEach(lineItemError => {
        if (lineItemError) {
          const errorText = lineItemError.querySelector('.cart-item__error-text');
          if (errorText) {
            errorText.innerHTML = message;
          }
          
          if (message && message.trim() !== '') {
            lineItemError.classList.remove('hidden');
            lineItemError.setAttribute('aria-hidden', 'false');
          } else {
            lineItemError.classList.add('hidden');
            lineItemError.setAttribute('aria-hidden', 'true');
          }
        }
      });
    });

    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const node = doc.querySelector(selector) || doc.querySelector('.shopify-section') || doc.body;
    return node ? node.innerHTML : '';
  }

  enableLoading(line) {
    const row = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    row?.classList.add('is-updating');
    row?.querySelectorAll('.loading__spinner').forEach((el) => el.classList.remove('hidden'));
    document.activeElement?.blur();
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const row = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    row?.classList.remove('is-updating');
    row?.querySelectorAll('.loading__spinner').forEach((el) => el.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => { try { window.CartPerformance?.measureFromEvent?.('note-update:user-action', event); } catch (e) {} });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}